import { render, staticRenderFns } from "./ItemsTab.vue?vue&type=template&id=294f7d93&scoped=true&"
import script from "./ItemsTab.vue?vue&type=script&lang=js&"
export * from "./ItemsTab.vue?vue&type=script&lang=js&"
import style0 from "./ItemsTab.vue?vue&type=style&index=0&id=294f7d93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294f7d93",
  null
  
)

export default component.exports